import { useEffect, useState } from 'react';
import {
  GetSpecialtyProviders,
  type SpecialtyProvider,
  unwrapSpecialtyPayload,
} from '@/apis/specialtyBooking';

/** Specialty carriers this company can book through the API (empty while loading or on error). */
const useSpecialtyProviders = (
  token: string | null | undefined
): SpecialtyProvider[] => {
  const [providers, setProviders] = useState<SpecialtyProvider[]>([]);

  useEffect(() => {
    if (!token) {
      setProviders([]);
      return;
    }
    let cancelled = false;
    GetSpecialtyProviders(token)
      .then((res) => {
        if (cancelled) return;
        const payload = unwrapSpecialtyPayload<{
          providers: SpecialtyProvider[];
        }>(res);
        setProviders(
          Array.isArray(payload?.providers) ? payload.providers : []
        );
      })
      .catch(() => {
        if (!cancelled) setProviders([]);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return providers;
};

export default useSpecialtyProviders;
